export default "__VITE_ASSET__0a56816b__"